<template>
  <el-row>
    <div class="file-upload">
      <el-upload class="file-uploader"
                 :show-file-list="false"
                 :action="uploadUrl"
                 :headers="headers"
                 :before-upload="handleBeforeUpload"
                 :on-change="handleChange"
                 :on-success="handleSuccess"
                 :on-error="handleError"
                 multiple>
        <el-button size="small"
                   type="primary">Upload File</el-button>
        <div class="el-upload__tip"
             slot="tip"></div>
      </el-upload>
    </div>
    <el-button v-for="value in tabs" :key="value.name" @click.native.prevent="getFilesByYear(value.year)"> {{ value.name }}</el-button>

    <a target="_blank"
             class="download-button" style="float:right"
             :href="axios.defaults.baseURL + '/documents/' +  this.$route.params.userID + '/downloadAll?year=' + this.selectedYear+`&token=${token}`">
             Download All<i class="el-icon-download"></i>
    </a>


    <el-table :data="documentList"
              style="width: 100%">
      <el-table-column prop="name"
                       label="File Name">
      </el-table-column>
       <el-table-column prop="formatedModified"
                       label="File Modified Time" style="float:right">
      </el-table-column>
      <el-table-column fixed="right"
                       header-align="center"
                       align="center"
                       label="Operations"
                       width="140">
        <template slot-scope="scope">
          <a target="_blank"
             class="download-button"
             :href="scope.row.url+`&token=${token}`">
            <i class="el-icon-download"></i>
          </a>
          <el-button @click.native.prevent="deleteFile(scope.row)"
                     type="danger"
                     icon="el-icon-delete"
                     size="small"></el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-row>
</template>

<script>
export default {
  created() {
    this.getFiles();
  },
  data() {
    return {
      headers: { Authorization: 'Bearer ' + localStorage.token },
      documentList: [],
      uploadUrl:
        this.axios.defaults.baseURL + "/document/" +
        this.$route.params.userID,
      token: localStorage.token,
      tabs: [],
      selectedYear: ""
    };
  },
  methods: {
    getTabs() {
        this.tabs = [];
        if(this.documentList === undefined){
          return;
        }
        var re1 = /20\d{2}\d*/g;
        //let re2 = RegExp('^(20\\d{2})\\D', 'g');
        var years = [];
        this.documentList.forEach((file) => {
          //file.name = 'd2019 2018kkk201999gg201 aa'
          //console.log(file.name);
	  file.formatedModified = new Date(file.modified).toLocaleString();
          var year = new String();
          while (year = re1.exec(file.name)) {
            if(year[0].length == 4 && years.indexOf(year[0])< 0){
              years.push(year[0])
            }
          }
        });
        years.sort();
        years.reverse();
//        this.tabs.push()
        this.tabs.push({name: 'All', year: ''});
        years.forEach((yy) => {
            this.tabs.push({name: yy, year: yy});
        });
    },
    getFiles() {
     var d = new Date();
     var n = d.getTime();
     this.axios({
        method: 'get',
//        headers: { 'Pragma': 'no-cache' },
//        headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' },
//        adapter: cacheAdapterEnhancer(axios.defaults.adapter),
        url: `/documents/${this.$route.params.userID}/` + n
      }).then(res => {
        this.documentList = res.data.files;
//        this.fileList = res.data.files;
        this.getTabs();
      });

      // this.axios({
      //   method: 'get',
      //   url: this.axios.defaults.baseURL + `/documents/${this.$route.params.userID}`,
      // }).then(res => {
      //   this.documentList = res.data.files;
      //   this.getTabs();
      // });
    },
    getFilesByYear(year){
//      console.log(year);
      this.axios({
        method: 'get',
        url: `/documents/${this.$route.params.userID}`,
        params: {
          year: year,
        },

      }).then(res => {
        //console.log(res);
        this.selectedYear = year;
        this.documentList = res.data.files;
      });
 
    },
    deleteFile(file) {
      this.$confirm(
        'This will permanently delete the file. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
          this.axios({
            method: 'delete',
            url: `/document/${this.$route.params.userID}`,
            params: {
              name: file.name,
            },
          }).then(res => {
            if (res.data.success) {
              this.documentList = this.documentList.filter(
                row => row.name !== file.name
              );
              this.getTabs();
              this.$message({
                center: true,
                message: 'Delete Success',
                type: 'success',
                showClose: true,
              });
            } else {
              this.$message({
                center: true,
                message: 'Delete Fail',
                type: 'fail',
                showClose: true,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled',
          });
        });
    },
    handleBeforeUpload(file) {
      if(this.documentList === undefined){
          return;
      }
      if (this.documentList.filter(row => row.name === file.name).length !== 0) {
        this.$message({
          message:
            'Upload Cancel. You have same file name, please delete old file to upload new.',
          type: 'warning',
        });
        return false;
      }
    },
    viewFile(row) {
      this.axios({
        method: 'get',
        url: row.url,
        responseType: 'blob',
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', row.name);
        document.body.appendChild(link);
        link.click();
      });
    },

    handleChange() {},
    handleSuccess(res, file, documentList) {
      if (res.success) {
        this.$message({
          center: true,
          message: 'Upload Success',
          type: 'success',
          showClose: true,
        });
        this.getFiles();
      }
    },
    handleError() {
      this.$message({
        center: true,
        message: 'Upload Fail',
        type: 'error',
        showClose: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme/element-variables';
.download-button {
  color: #ffffff;
  background-color: $--color-primary;
  border: 1px solid $--color-primary;
  border-radius: 3px;
  padding: 9px 15px;
  font-size: 12px;
  display: inline-block;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/user/DocumentList.vue